import APIService from '@/services/APIService.js';

export default {

  getAllCadernos() {
    return APIService.apiCall().get('/relatorioCadernoServicos/getAllCadernos');
  },

  salvarCadernoServicos(postData) {
    return APIService.apiCall().post(`/relatorioCadernoServicos/salvar`, JSON.stringify(postData));
  },

  excluirCadernoServicos(id) {
    return APIService.apiCall().get(`/relatorioCadernoServicos/excluir/${id}`);
  },

  executarCadernoServicos(id) {
    return APIService.apiCall().get(`/relatorioCadernoServicos/executar/${id}`);
  },

  download(id, config = {}) {
    return APIService.apiCall().get(`/relatorioCadernoServicos/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  },
};
